<template>
  <div class="container ps-lg-5 pe-lg-5">
    <div class="row">
      <div class="col-12 col-lg-12 mt-lg-5 text-center">
        <div class="icon-thankyou">
          <img src="@/assets/images/icon-thankyou.svg" class="w-100" />
        </div>
        <h1 class="blue-1 fw-normal">THANK YOU</h1>
        <h3 class="blue-1 fw-normal name font-family">
          เรียนคุณ {{ this.$store.state.UserName }}
        </h3>
        <div class="content pt-lg-3 fw-normal font-family fs-4">
          <p style="margin-bottom: 0rem">ท่านดำเนินการเปลี่ยนแปลง{{this.$store.state.Otp.ISEMAIL ? "อีเมล":"เบอร์มือถือ"}}สำเร็จ</p>          
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-2 col-sm-4"></div>
            <div class="col font-family fs-4">
              <p style="margin-bottom: 0rem">
                ท่านสามารถติดตามสถานะของรายการได้จาก
              </p>
              <ul class="">
                <li>เมนู e-Request >> ประวัติการแก้ไข</li>
                <li>การแจ้งเตือนผ่าน BLA Easy Click</li>
                <li>อีเมลที่ให้ไว้กับบริษัท</li>
              </ul>
            </div>
            <div class="col-2 col-sm-4"></div>
          </div>
        </div>
        <div class="content pt-lg-2 fw-normal fs-4">
          <p class="font-family" style="margin-bottom: 0rem">
            หากท่านมีข้อสงสัยกรุณาติดต่อ
          </p>
          <p class="font-family" style="margin-bottom: 0rem">
            ส่วนสัญญาตัวแทน บมจ.กรุงเทพประกันชีวิต
          </p>
          <p class="blue-1 fw-bold fs-6">0-2777 8559-60, 0-2777-8567</p>
        </div>
        <div class="mt-lg-4 mb-lg-4 d-none d-none d-lg-block">
          <router-link to="/AgenteService" class="btn-back fw-normal font-family text-decoration-none"> กลับไปหน้าแรก </router-link>
        </div>
        <router-link to="/AgenteService" class="btn-back mt-1 mb-2 fw-normal d-lg-none font-family text-decoration-none"> กลับไปหน้าแรก </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinishEmailMobileView",
};
</script>

<style scoped>
.name {
  font-size: 30px;
  font-size: 1.875rem;
}
</style>